/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from '@/components/Dialog';
import PerspectiveAttachment from '../../../perspectives/PerspectiveAttachment';
import StyledDialog from '../../../TaskBoard/KanbanPhaseColumn/CreateTask/PerspectiveAttachmentDialog/StyledDialog';
import PerspectiveAttachmentContext from '@/components/ChallengePortfolio/NormalView/perspectives/PerspectiveAttachmentContext';
import useAttachmentState from '../../../perspectives/useAttachmentState';
import { useCallback, useContext } from 'react';
import TaskContext from '../TaskContext';
import useIsPortfolioReadonly from '../../../useIsPortfolioReadonly';
import useBlockPortfolioItemCloseWhenDirty from '../../../portfolio-item/useBlockPortfolioItemCloseWhenDirty';

type PerspectiveAttachmentDialogProps = {
  open: boolean;
  onClose: () => void;
  onSave: (
    attachedPerspectives: number[],
    attachedSublevels: number[],
  ) => Promise<void>;
};

function getKeysWithTrueValue(object: Record<number, boolean>): number[] {
  return Object.entries(object)
    .filter(([, value]) => !!value)
    .map(([key]) => Number(key));
}

const PerspectiveAttachmentDialog = ({
  open,
  onClose,
  onSave,
}: PerspectiveAttachmentDialogProps) => {
  const isPortfolioReadOnly = useIsPortfolioReadonly();
  const [task] = useContext(TaskContext);

  const {
    attachedPerspectives,
    attachedSublevels,
    attachPerspective,
    detachPerspective,
    attachSublevel,
    detachSublevel,
    reenableAttachmentStateSync,
    anySublevelAttached,
    hasUnsavedChanges,
  } = useAttachmentState(task);

  const handleSave = useCallback(async (): Promise<void> => {
    await onSave(
      getKeysWithTrueValue(attachedPerspectives),
      getKeysWithTrueValue(attachedSublevels),
    );

    reenableAttachmentStateSync();
  }, [attachedPerspectives, attachedSublevels]);

  useBlockPortfolioItemCloseWhenDirty(hasUnsavedChanges, handleSave);

  return (
    <StyledDialog open={open} onClose={onClose}>
      <PerspectiveAttachmentContext.Provider
        value={{
          attachmentActive: true,
          attachedPerspectives,
          attachedSublevels,
          attachPerspective,
          detachPerspective,
          attachSublevel,
          detachSublevel,
          anySublevelAttached,
        }}
      >
        <PerspectiveAttachment />
      </PerspectiveAttachmentContext.Provider>
      <Dialog.Actions>
        {isPortfolioReadOnly ? (
          <Dialog.Actions.DoneButton onClick={onClose} />
        ) : (
          <>
            <Dialog.Actions.CancelButton onClick={onClose} />
            <Dialog.Actions.SaveButton onClick={handleSave} />
          </>
        )}
      </Dialog.Actions>
    </StyledDialog>
  );
};

export default PerspectiveAttachmentDialog;
